import { $_WC, $_NM, $_TYPE } from '@/confs/common.const';
import MarkerClustering from "@/libs/grip.naver.map.marker.clustering.js";
import MarkerOverlappingRecognizer from "@/libs/grip.naver.map.marker.overlapping.recognizer.js";
export default {
    data() {
        return {
            cluster: {
                maxZoom: 20,                    // 클러스터링 할 최대 줌 레벨
                gridSize: 100 * $_WC.viewScale,  // 클러스터링 할 범위
                minSize: 2,                     // 클러스터링 할 최소 마커 수
                generator: [10, 100, 200, 500, 1000],   // 클러스터 크기 구간
                clickZoom: true,
                icons: [
                    {
                        content: `<div style="cursor:pointer; width: ${(32 * $_WC.viewScale)}px;
                            height: ${(32 * $_WC.viewScale)}px; line-height: ${(32 * $_WC.viewScale)}px;
                            font-size: ${(10 * $_WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$_WC.assets + 'img/marker2/cluster-marker-1.png'});
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                    {
                        content: `<div style="cursor:pointer; width: ${(40 * $_WC.viewScale)}px;
                            height: ${(40 * $_WC.viewScale)}px; line-height: ${(40 * $_WC.viewScale)}px;
                            font-size: ${(12 * $_WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$_WC.assets + 'img/marker2/cluster-marker-2.png'});
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                    {
                        content: `<div style="cursor:pointer; width: ${(48 * $_WC.viewScale)}px;
                            height: ${(48 * $_WC.viewScale)}px; line-height: ${(48 * $_WC.viewScale)}px;
                            font-size: ${(14 * $_WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$_WC.assets + 'img/marker2/cluster-marker-3.png'});
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                    {
                        content: `<div style="cursor:pointer; width: ${(56 * $_WC.viewScale)}px;
                            height: ${(56 * $_WC.viewScale)}px; line-height: ${(56 * $_WC.viewScale)}px;
                            font-size: ${(16 * $_WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$_WC.assets + 'img/marker2/cluster-marker-4.png'});
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                    {
                        content: `<div style="cursor:pointer; width: ${(64 * $_WC.viewScale)}px;
                            height: ${(64 * $_WC.viewScale)}px; line-height: ${(64 * $_WC.viewScale)}px;
                            font-size: ${(18 * $_WC.viewScale)}px; color: white; text-align: center;
                            font-weight: bold;background:url(${$_WC.assets + 'img/marker2/cluster-marker-5.png'});
                            background-size:contain;"></div>`,
                        size: N.Size(40, 40),
                        anchor: N.Point(20, 20)
                    },
                ],
            },
            geoJsonKeyType: {
                prop: 'prop',
                file: 'file',
                feature: 'feature',
            },
        }
    },
    computed: {
        map() {
            return this.$store.getters.getNaverMaps;
        },

        geoJsonDrawing() {
            return this.$store.getters.getGeoJsonDrawing;
        },

        markerMap() {
            return this.$store.getters.getMarkerMap;
        },

        selectedMarker() {
            return this.$store.getters.getSelectedMarker;
        },

        addongList() {
            return this.$store.getters.getAddongList;
        },
        polygonMap() {
            return this.$store.getters.getPolygonMap;
        },
        polylineMap() {
            return this.$store.getters.getPolylineMap;
        },
        heatmapMap() {
            return this.$store.getters.getHeatmapMap;
        },
        circleMap() {
            return this.$store.getters.getCircleMap;
        },

        curInfoWindow() {
            return this.$store.getters.fetchedCurInfoWindow;
        },
        markerClustering() {
            return this.$store.getters.getMarkerClustering;
        },
        trafficLayer() {
            return this.$store.getters.getTrafficLayer;
        },
        cadastralLayer() {
            return this.$store.getters.getCadastralLayer;
        },
        recognizer(){
            return this.$store.getters.getRecognizer;
        },
    },

    methods: {
        // 해당 키의 마커목록 존재 여부
        hasMarkers(key) {
            return (typeof this.markerMap[key] !== 'undefined' && this.markerMap[key].length > 0);
        },

        // 해당 키의 마커목록을 지도에 보여주거나 감춘다.
        showMarkers(key, isShow, isBound) {
            if(typeof this.map !== 'undefined') {
                if(typeof isBound === 'undefined') {
                    isBound = false;
                }
                let mapBounds = this.map.getBounds();
                if(this.hasMarkers(key)) {
                    this.markerMap[key].forEach(function(marker) {
                        if(isShow) {
                            // 보여지는 영역만 마커를 그리는 로직 추가 - 전체에 적용하기 어려움
                            if(isBound) {
                                let position = marker.getPosition();
                                if(mapBounds.hasLatLng(position)) {
                                    marker.setMap(this.map);
                                } else {
                                    marker.setMap(null);
                                }
                            } else {
                                marker.setMap(this.map);
                            }
                        } else {
                            if(typeof marker.infoWindow !== 'undefined') {
                                this.closeInfoWin(marker.infoWindow);
                            }
                            if(typeof this.recognizer != 'undefined') {
                                this.recognizer.remove(marker);
                            }
                            marker.setMap(null);
                        }
                    }.bind(this));
                }
            }
        },

        // 해당영역만 마커를 보여준다
        markerViewCtrl(markers) {
            let mapBounds = this.map.getBounds();
            markers.forEach(function(marker){
                let position = marker.getPosition();
                if (mapBounds.hasLatLng(position)) {
                    this.showMarkerView(marker);
                } else {
                    this.hideMarkerView(marker);
                }
            }.bind(this));
        },
        showMarkerView(marker) {
            if (marker.getMap()) return;
            marker.setMap(this.map);
        },
        hideMarkerView(marker) {
            if (!marker.getMap()) return;
            marker.setMap(null);
        },

        showClusterMarkers (key, isShow) {
            if(this.hasMarkers(key)) {
                if(typeof this.markerClustering[key] === 'undefined') {
                    if(isShow) {
                        let cluster = this.markerClustering;
                        cluster[key] = new MarkerClustering({
                            minClusterSize: this.cluster.minSize,
                            maxZoom: this.cluster.maxZoom,
//                            map: this.map,
                            markers: this.markerMap[key],
                            disableClickZoom: !this.cluster.clickZoom,
                            gridSize: this.cluster.gridSize,
                            icons: this.cluster.icons,
                            indexGenerator: this.cluster.generator,
                            stylingFunction(clusterMarker, count) {
                                $(clusterMarker.getElement()).find('div:first-child').text(count);
                            }
                        });
                        this.$store.dispatch("SET_MARKER_CLUSTERING", cluster);
                        this.markerClustering[key].setMap(this.map);
                    }
                } else {
                    if(isShow) {
                        this.markerClustering[key].setMap(this.map);
                    } else {
                        this.markerClustering[key].setMap(null);
                    }
                }
            }
        },

        makeCadastralLayer(zIndex){
            let cadastralLayer = new naver.maps.CadastralLayer();

            let tileSize = [$_WC.mapTileSize * $_WC.viewScale, $_WC.mapTileSize * $_WC.viewScale];
            let opts = cadastralLayer.getLayerType().getMapTypeOptions();
            opts.tileSize = tileSize;
            cadastralLayer.getLayerType().setMapTypeOptions(opts);

            this.$store.dispatch("SET_CADASTRAL_LAYER", cadastralLayer);
        },
        showCadastralLayer(isShow) {
            if(typeof this.cadastralLayer !== 'undefined') {
                if(isShow) {
                    this.cadastralLayer.setMap(this.map);
                } else {
                    this.cadastralLayer.setMap(null);
                }
            }
        },

        makeTrafficLayer(zIndex) {
            let trafficLayer = new naver.maps.TrafficLayer({
                interval: 1000 * 60 * 10, // 10 분마다 갱신
            });

            // 폴리곤위로 올려야하는 경우 별도로 레이어를 띄운다
            if(typeof zIndex !== 'undefined' && zIndex !== '') {
                trafficLayer.options.overlayMap = false;
                trafficLayer.options.zIndex = zIndex;
            }

            // 타일 사이즈 조절
            let tileSize = [$_NM.TILE_SIZE * $_NM.TILE_SIZE_SCALE, $_NM.TILE_SIZE * $_NM.TILE_SIZE_SCALE];

            let opts = trafficLayer.getLayerType().getMapTypeOptions();
            opts.tileSize = tileSize;
            trafficLayer.getLayerType().setMapTypeOptions(opts);

            this.$store.dispatch("SET_TRAFFIC_LAYER", trafficLayer);
        },

        showTrafficLayer(isShow) {
            if(typeof this.trafficLayer !== 'undefined') {
                if(isShow) {
                    this.trafficLayer.setMap(this.map);
                } else {
                    this.trafficLayer.setMap(null);
                }
            }
        },

        addMarkerMap(key, marker){
            if(typeof this.markerMap[key] === 'undefined') {
                this.markerMap[key] = [];
            }
            this.markerMap[key].push(marker);
        },

        // 마커 생성
        makeMarker(key, data, clickMarkerHandle, imgFileNm, imgPath, w, h, title) {
            if(typeof this.markerMap[key] === 'undefined') {
                this.markerMap[key] = [];
            }
            if(typeof title === 'undefined') {
                title = '';
            }
            if(typeof imgPath === 'undefined') {
                imgPath = 'img/marker/';
            }

            if(typeof w === 'undefined') {
                w = 32;
            }

            if(typeof h === 'undefined') {
                h = 40;
            }

            // 마커 크기 조정 (화면배율)
            w = w * ($_WC.viewScale <= 1 ? 1 : 1.5);
            h = h * ($_WC.viewScale <= 1 ? 1 : 1.5);

            let marker = new naver.maps.Marker({
                position: new naver.maps.LatLng(data.lttdVal, data.lgtdVal),
                title: title,
                icon: {
                    url: $_WC.assets + imgPath + imgFileNm,
                    size: new naver.maps.Size(w, h),
                    origin: new naver.maps.Point(0, 0),
                    anchor: new naver.maps.Point((w / 2), h),
                    scaledSize: new naver.maps.Size(w, h)
                }
            });

            // 데이터 연결
            marker.data = data;

            if(typeof clickMarkerHandle === 'function') {
                naver.maps.Event.addListener(marker, 'click', (event)=>{
                    this.$store.dispatch("SET_SELECTED_MARKER", marker);
                    clickMarkerHandle(event, data, marker);
                });
                if(typeof this.recognizer !== 'undefined' && title !== '') {
                    // console.log( this.recognizer );
                    this.recognizer.add(marker);
                }
            }
            this.markerMap[key].push(marker);

            return marker;
        },

        setRecognizer(){
            let recognizer = new MarkerOverlappingRecognizer({
                highlightRect: false,
                tolerance: 5
            });
            recognizer.setMap(this.map);
            this.$store.dispatch("SET_RECOGNIZER", recognizer);
        },

        addClickMarkerListener(key, clickMarkerHandle, imgFileNm, imgPath, w, h) {
            if(typeof this.markerMap[key] === 'undefined') {
                this.markerMap[key] = [];
            }
            naver.maps.Event.addListener(this.map, 'click', function(event) {
                var clickEvent = event;
                this.showMarkers(key, false);
                var point = event.coord;
                var marker = new naver.maps.Marker({
                    map: this.map,
                    position: point,
                    icon: {
                        url: imgPath + imgFileNm,
                        size: new naver.maps.Size(w, h),
                        origin: new naver.maps.Point(0, 0),
                    }
                });

                if(typeof clickMarkerHandle === 'function') {
                    naver.maps.Event.addListener(marker, 'click', function(event) {
                        this.$store.dispatch("SET_SELECTED_MARKER", marker);
                        clickMarkerHandle(clickEvent, event, marker);
                    }.bind(this));

                    naver.maps.Event.trigger(marker, 'click', null);
                }
                this.markerMap[key].push(marker);
            }.bind(this));
        },

        naverMapTrigger(marker, event, etc){
            naver.maps.Event.trigger(marker, event, etc);
        },

        removeMarker(key) {
            if(this.hasMarkers(key)) {
                this.showMarkers(key, false);
                this.showClusterMarkers(key, false);
                delete this.markerMap[key];
            }
        },

        removeAllMarker() {
            var markerMap = this.markerMap;

            for(var key in markerMap) {
                this.showMarkers(key, false);
                this.showClusterMarkers(key, false);
                delete this.markerMap[key];
            }
        },

        disableMarker(key) {
            if(this.hasMarkers(key)) {
                this.showMarkers(key, false);
                this.showClusterMarkers(key, false);
            }
        },

        disableAllMarker() {
            let markerMap = this.markerMap;

            for(let key in markerMap) {
                this.showMarkers(key, false);
                this.showClusterMarkers(key, false);
            }
        },

        // 해당 키의 마커목록 존재 여부
        hasPolygons(key) {
            return (typeof this.polygonMap[key] !== 'undefined' && this.polygonMap[key].length > 0);
        },

        // 해당 키의 마커목록을 지도에 보여주거나 감춘다.
        showPolygons(key, isShow) {
//            console.log( key, this.polygonMap[key] );
            if(this.hasPolygons(key)) {
                this.polygonMap[key].forEach(function(polygon) {
                    if(isShow) {
                        polygon.setMap(this.map);
                    } else {
                        polygon.setMap(null);
                    }
                }.bind(this));
            }
        },

        // 해당 키의 마커목록 존재 여부
        hasPolylines(key) {
            return (typeof this.polylineMap[key] !== 'undefined' && this.polylineMap[key].length > 0);
        },

        // 해당 키의 마커목록을 지도에 보여주거나 감춘다.
        showPolylines(key, isShow) {
            if(this.hasPolylines(key)) {
                this.polylineMap[key].forEach(function(polyline) {
                    if(isShow) {
                        polyline.setMap(this.map);
                    } else {
                        polyline.setMap(null);
                    }
                }.bind(this));
            }
        },

        makePolygon(geoJsonKeyType, key, geoJsonUrl, color, opacity, clickHandle, mapKey) {
            // type: prop or file prop인 경우 key는 프로퍼티명
            let keyNm = key;

            axios.get(geoJsonUrl).then((res)=>{
                let geoJson = JSON.parse(unescape(JSON.stringify(res.data)));
                let newFeatures = geoJson.features;

                newFeatures.map((currVal, idx, arr)=>{
                    if(geoJsonKeyType === this.geoJsonKeyType.prop) {
                        let prop = currVal.properties;
                        keyNm = prop[key];
                    } else if(geoJsonKeyType === this.geoJsonKeyType.feature) {
                        keyNm = currVal[key];
                    }

                    let coordinates = currVal.geometry.coordinates;
                    coordinates.forEach((paths, index)=>{
                        let newPaths = paths;
                        if(newPaths.length == 1) {
                            newPaths = newPaths[0];
                        }
                        this.drawPolygon(keyNm, newPaths, color, opacity, clickHandle, mapKey);
                    });
                });
            });
        },

        makePolygonByTradr(geoJsonKeyType, key, geoJsonUrl, colors, colorRanges, opacity, clickHandle, mapKey, listMap, strokeColor, strokeWeight) {
            // type: prop or file prop인 경우 key는 프로퍼티명
            let keyNm = key;
            axios.get(geoJsonUrl).then((res)=>{
                let geoJson = JSON.parse(unescape(JSON.stringify(res.data)));
                let newFeatures = geoJson.features;

                newFeatures.map((currVal, idx, arr)=>{
                    let tmpKey = currVal.properties[key];
                    if(typeof listMap[tmpKey] !== 'undefined') {
                        let val = Number(listMap[tmpKey].val4) + Number(listMap[tmpKey].val5);
                        let colorScale = d3.scaleLinear().domain(colorRanges).range(colors);
                        let color = colorScale(Number(val));
                        if(geoJsonKeyType === this.geoJsonKeyType.prop) {
                            let prop = currVal.properties;
                            keyNm = prop[key];
                        } else if(geoJsonKeyType === this.geoJsonKeyType.feature) {
                            keyNm = currVal[key];
                        }

                        let coordinates = currVal.geometry.coordinates;
                        coordinates.forEach((paths, index)=>{
                            let newPaths = paths;
                            if(newPaths.length == 1) {
                                newPaths = newPaths[0];
                            }
                            this.drawPolygon(keyNm, newPaths, color, opacity, clickHandle, mapKey, strokeColor, strokeWeight);
                        });
                    }
                });
            });
        },

        makePolygonByString(geoJsonKeyType, key, geoJsonString, color, opacity, clickHandle, mapKey) {
            // type: prop or file prop인 경우 key는 프로퍼티명
            let keyNm = key;

            let geoJson = JSON.parse(geoJsonString);
            let newFeatures = geoJson.features;

            if(typeof newFeatures !== 'undefined') {
                newFeatures.map((currVal, idx, arr)=>{
                    if(geoJsonKeyType === this.geoJsonKeyType.prop) {
                        let prop = currVal.properties;
                        keyNm = prop[key];
                    } else if(geoJsonKeyType === this.geoJsonKeyType.feature) {
                        keyNm = currVal[key];
                    }

                    let coordinates = currVal.geometry.coordinates;
                    coordinates.forEach((paths, index)=>{
                        let newPaths = paths;
                        if(newPaths.length == 1) {
                            newPaths = newPaths[0];
                        }
                        this.drawPolygon(keyNm, newPaths, color, opacity, clickHandle, mapKey);
                    });
                });
            } else if(typeof geoJson.coordinates !== 'undefined') {
                let coordinates = geoJson.coordinates;
                coordinates.forEach((paths, index)=>{
                    let newPaths = paths;
                    if(newPaths.length == 1) {
                        newPaths = newPaths[0];
                    }
                    this.drawPolygon(keyNm, newPaths, color, opacity, clickHandle, mapKey);
                });
            }

        },

        drawPolygon(key, paths, color, opacity, clickHandle, mapKey, strokeColor, strokeWeight) {
            if(typeof mapKey === 'undefined') {
                mapKey = key;
            }

            let polygonOptions = {
                paths: paths,
                fillColor: color,
                fillOpacity: opacity,
                zIndex: 100,
                clickable: false
            };

            if(typeof strokeColor !== 'undefined' && strokeColor !== '') {
                polygonOptions['strokeColor'] = strokeColor;
            }
            if(typeof strokeWeight !== 'undefined' && strokeWeight !== '') {
                polygonOptions['strokeWeight'] = strokeWeight;
            }

            if(typeof this.polygonMap[mapKey] === 'undefined') {
                this.polygonMap[mapKey] = [];
            }

            let polygon = new naver.maps.Polygon(polygonOptions);

            if(typeof clickHandle === 'function') {
                polygon.setClickable(true);
                naver.maps.Event.addListener(polygon, 'click', function(event) {
                    polygon.coord = event.coord;
                    this.$store.dispatch("SET_SELECTED_MARKER", polygon);
                    clickHandle(key, event);
                }.bind(this));
            }

            this.polygonMap[mapKey].push(polygon);
            polygon.setMap(this.map);
        },

        removePolygon(key) {
            if(this.hasPolygons(key)) {
                this.showPolygons(key, false);
                delete this.polygonMap[key];
            }
        },

        removeAllPolygon() {
            var polygonMap = this.polygonMap;
            for(var key in polygonMap) {
                this.removePolygon(key);
            }
        },

        disableAllPolygon() {
            let polygonMap = this.polygonMap;
            for(let key in polygonMap) {
                this.showPolygons(key, false);
            }
        },

        // 폴리라인이 파일인 경우
        makePolyline(geoJsonKeyType, key, geoJsonUrl, strokeColor, strokeWeight, strokeStyle, showIcon, opacity, clickHandle, mapKey) {
            // type: prop or file prop인 경우 key는 프로퍼티명
            let keyNm = key;

            axios.get(geoJsonUrl).then(function(res) {
                let geoJson = JSON.parse(unescape(JSON.stringify(res.data)));

                let newFeatures = [];
                if(geoJson.type === 'Feature') {
                    newFeatures[0] = geoJson;
                } else {
                    // FeatureCollection
                    newFeatures = geoJson.features;
                }

                newFeatures.map(function(currVal, idx, arr) {
                    if(geoJsonKeyType === this.geoJsonKeyType.prop) {
                        let prop = currVal.properties;
                        keyNm = prop[key];
                    } else if(geoJsonKeyType === this.geoJsonKeyType.feature) {
                        keyNm = currVal[key];
                    }

                    let geometryType = currVal.geometry.type;
                    let coordinates = [];
                    if(geometryType === 'LineString') {
                        coordinates[0] = currVal.geometry.coordinates;
                    } else {
                        // MultiLineString
                        coordinates = currVal.geometry.coordinates;
                    }
                    coordinates.forEach(function(paths, index) {
                        let newPaths = paths;
                        if(newPaths.length == 1) {
                            newPaths = newPaths[0];
                        }
                        this.drawPolyline(keyNm, newPaths, strokeColor, strokeWeight, strokeStyle, showIcon, opacity, clickHandle, mapKey);
                    }, this);
                }.bind(this));
            }.bind(this));
        },

        drawPolyline(key, paths, strokeColor, strokeWeight, strokeStyle, showIcon, opacity, clickHandle, mapKey, startIcon, endIcon) {
            if(typeof mapKey === 'undefined') {
                mapKey = key;
            }
            if(typeof this.polylineMap[mapKey] === 'undefined') {
                this.polylineMap[mapKey] = [];
            }

            if(typeof strokeStyle === 'undefined') {
                strokeStyle = 'solid';
            }

            

            let polyline = new naver.maps.Polyline({
                path: paths,
                strokeColor: strokeColor,
                strokeOpacity: opacity,
                strokeWeight: Math.ceil(strokeWeight * $_WC.viewScale),
                strokeStyle: strokeStyle,
                strokeLineJoin: 'round',
                zIndex: 100,
                startIcon: startIcon,
                startIconSize: Math.ceil(strokeWeight * $_WC.viewScale) * 2,
                endIcon: endIcon,
                endIconSize: Math.ceil(strokeWeight * $_WC.viewScale) * 2,
            });

            if(showIcon) {
                polyline.setOptions({
                    startIcon: 3,
                    startIconSize: Math.ceil(strokeWeight * $_WC.viewScale) * 2,
                    endIcon: 3,
                    endIconSize: Math.ceil(strokeWeight * $_WC.viewScale) * 2,
                });
            }

            if(typeof clickHandle === 'function') {
                polyline.setClickable(true);
                naver.maps.Event.addListener(polyline, 'click', function(event) {
                    polyline.coord = event.coord;
                    this.$store.dispatch("SET_SELECTED_MARKER", polyline);
                    clickHandle(key, event);
                }.bind(this));

                //naver.maps.Event.trigger(marker, 'click', null);
            }

            this.polylineMap[mapKey].push(polyline);
            polyline.setMap(this.map);
        },

        removePolyline(key) {
            if(this.hasPolylines(key)) {
                this.showPolylines(key, false);
                delete this.polylineMap[key];
            }
        },

        removeAllPolyline() {
            var polylineMap = this.polylineMap;

            for(var key in polylineMap) {
                this.removePolyline(key);
            }
        },

        setPolylineStrokeColor(key, strokeColor) {
            if(this.hasPolylines(key)) {
                this.polylineMap[key].forEach(function(polyline) {
                    polyline.setOptions("strokeColor", strokeColor);
                }.bind(this));
            }
        },

        disableAllPolyline() {
            let polylineMap = this.polylineMap;
            for(let key in polylineMap) {
                this.showPolylines(key, false);
            }
        },


        hasHeatmaps(key) {
            return (typeof this.heatmapMap[key] !== 'undefined');
        },
        makeHeatmap(key, coordinates){
            if(coordinates.length > 0) {
                let heatmap = new naver.maps.visualization.HeatMap({
                    radius: 10,
                    data: coordinates,
                });
                this.heatmapMap[key] = heatmap;
            }
        },
        showHeatmaps(key, isShow) {
            if(this.hasHeatmaps(key)){
                if(isShow) {
                    this.heatmapMap[key].setMap(this.map);
                } else {
                    this.heatmapMap[key].setMap(null);
                }
            }
        },

        // 해당 키의 마커목록 존재 여부
        hasCircles(key) {
            return (typeof this.circleMap[key] !== 'undefined' && this.circleMap[key].length > 0);
        },

        // 해당 키의 마커목록을 지도에 보여주거나 감춘다.
        showCircles(key, isShow) {
            if(this.hasCircles(key)) {
                this.circleMap[key].forEach(function(circle) {
                    if(isShow) {
                        circle.setMap(this.map);
                    } else {
                        circle.setMap(null);
                    }
                }.bind(this));
            }
        },
        // 반경 표시
        makeCircle(key, lttdVal, lgtdVal, radius, fillColor, fillOpacity, isShow) {
            if(typeof this.circleMap[key] === 'undefined') {
                this.circleMap[key] = [];
            }
            let position = new naver.maps.LatLng(lttdVal, lgtdVal);
            this.drawCircle(key, position, radius, fillColor, fillOpacity, isShow);
        },

        drawCircle(key, position, radius, fillColor, fillOpacity, isShow) {
            let circle = new naver.maps.Circle({
                // map: this.map,
                center: position,
                radius: radius,
                fillColor: fillColor,
                fillOpacity: fillOpacity,
                strokeColor: fillColor,
                strokeWeight: 1,
            });

            this.circleMap[key].push(circle);
            if(isShow) {
                circle.setMap(this.map);
            }
        },

        removeCircle(key) {
            if(this.hasCircles(key)) {
                this.showCircles(key, false);
                delete this.circleMap[key];
            }
        },

        disableCircle(key) {
            if(this.hasCircles(key)) {
                this.showCircles(key, false);
            }
        },

        disableAllCircle() {
            let circleMap = this.circleMap;
            for(let key in circleMap) {
                this.showCircles(key, false);
            }
        },
        mapZoomIn() {
            let currZoom = this.map.getZoom();
            if(currZoom < $_NM.MAX_ZOOM) {
                this.map.setZoom(currZoom + 1, true);
            }
        },
        mapZoomOut() {
            let currZoom = this.map.getZoom();
            if(currZoom > $_NM.MIN_ZOOM) this.map.setZoom(currZoom - 1, true);
        },
        openInfoWin(content) {
            let infoWindow = new naver.maps.InfoWindow({
                content: content,
            });

            if(this.selectedMarker.OVERLAY_TYPE === 'Marker') {
                infoWindow.open(this.map, this.selectedMarker);
            } else {
                infoWindow.open(this.map, this.selectedMarker.coord);
            }

            // ie 오류로 변경
            let closeBtns = infoWindow.contentElement.querySelectorAll('a.self-close-btn');
            for(let i = 0; i < closeBtns.length; i++) {
                let el = closeBtns[i];
                el.addEventListener('click', (event)=>{
                    event.preventDefault();
                    // if(this.$store.getters.getSelectedSubMenu === 'mediumMosq') {
                    //     this.$store.dispatch("SET_SELECTED_ME_MOSQ", {});
                    // }
                    this.closeInfoWin(infoWindow);
                });
            }

            this.selectedMarker.infoWindow = infoWindow;
            this.$store.dispatch("SET_CUR_INFO_WINDOW", infoWindow);

            return infoWindow;
        },

        closeInfoWin(infoWindow) {
            let closeInfoWindow = infoWindow || this.curInfoWindow;
            if(closeInfoWindow != undefined) {
                closeInfoWindow.close();
            }

            if(closeInfoWindow === this.curInfoWindow) {
                this.$store.dispatch("SET_CUR_INFO_WINDOW", undefined);
            }
        },
        clickOverlayWin(map, event) {
            let html = '<div class="popup_st21">';
            html += '<div class="popup_wrap">';
            html += '<div class="title"><span class="t01">nameeeee</span></div>';
            html += '<div class="text">';
            html += '<span class="pop_bt_state red">name222222</span>';
            html += '<span>addrrrrrrrrrrr</span>';
            html += '</div>';
            html += '<div class="pop_table03">';
            html += '<table>';
            html += '<colgroup>';
            html += '<col style="width: 40%;">';
            html += '<col style="width: 60%;">';
            html += '</colgroup>';
            html += '<tbody>';
            html += '<tr>';
            html += '<th>test</th>';
            html += '<td>1234</td>';
            html += '</tr>';
            html += '</tbody>';
            html += '</table>';
            html += '</div>';
            html += '<div class="pop_bt_close2"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>';
            html += '</div>';
            html += '</div>';

            let CctvOverlay = function(options) {
                this._element = $(html);
                this.setPosition(options.position);
                this.setMap(options.map || null);
            }

            CctvOverlay.prototype = new naver.maps.OverlayView();
            CctvOverlay.prototype.constructor = CctvOverlay;

            CctvOverlay.prototype.setPosition = function(position) {
                this._position = position;
                this.draw();
            };

            CctvOverlay.prototype.getPosition = function() {
                return this._position;
            };

            CctvOverlay.prototype.onAdd = function() {
                let paneName = "floatPane";
                let floatPane = this.getPanes()[paneName];
                this._element.appendTo(floatPane);
            };

            CctvOverlay.prototype.draw = function() {
                if (!this.getMap()) {
                    return;
                }

                let projection = this.getProjection();
                let position = this.getPosition();
                let pixelPosition = projection.fromCoordToOffset(position);
                let heightOffset = this._element.height();

                this._element.css('left', pixelPosition.x);
                this._element.css('top', pixelPosition.y - heightOffset);

                this._element.draggable();
                this._element.on('mousedown', function() {
                    map.setOptions({ //지도 인터랙션 끄기
                        draggable: false,
                        pinchZoom: false,
                        scrollWheel: false,
                        keyboardShortcuts: false,
                        disableDoubleTapZoom: true,
                        disableDoubleClickZoom: true,
                        disableTwoFingerTapZoom: true
                    });
                });

                this._element.on('touchstart', function() {
                    map.setOptions({ //지도 인터랙션 끄기
                        draggable: false,
                        pinchZoom: false,
                        scrollWheel: false,
                        keyboardShortcuts: false,
                        disableDoubleTapZoom: true,
                        disableDoubleClickZoom: true,
                        disableTwoFingerTapZoom: true
                    });
                });

                this._element.on('mouseup', function() {
                    map.setOptions({ //지도 인터랙션 끄기
                        draggable: true,
                        pinchZoom: true,
                        scrollWheel: true,
                        keyboardShortcuts: true,
                        disableDoubleTapZoom: false,
                        disableDoubleClickZoom: false,
                        disableTwoFingerTapZoom: false
                    });
                });


                this._element.on('touchend', function() {
                    map.setOptions({ //지도 인터랙션 끄기
                        draggable: true,
                        pinchZoom: true,
                        scrollWheel: true,
                        keyboardShortcuts: true,
                        disableDoubleTapZoom: false,
                        disableDoubleClickZoom: false,
                        disableTwoFingerTapZoom: false
                    });
                });
            };

            CctvOverlay.prototype.onRemove = function() {
                let overlayLayer = this.getPanes().overlayLayer;
                this._element.remove();
                this._element.off();
            };

            let overlay = new CctvOverlay({
                position: event.coord,
            });

            overlay.setMap(null);
            // 중심좌표 이동
            map.setCenter(new naver.maps.LatLng(event.coord));

            // CCTV 창 닫기 Event
            overlay._element.find(".self-close-btn").on("click", function(event) {
                event.preventDefault();
                overlay.setMap(null);
            });

            return overlay;
        },

        convertWgs84Coords(grs80TmY, grs80TmX, paramY) {
            let correctY=paramY?paramY:500000.0;
            let CS_M1 = 4207498.01915032 + (parseFloat(grs80TmY) - correctY) / 1.0;
            let CS_U1 = CS_M1 / 6378137.0 / (0.998326405 - 3.0 * Math.pow(0.00669438, 2.0) / 64.0 - 5.0 * Math.pow(0.00669438, 3.0) / 256.0);
            let CS_LAT1 = CS_U1 + (0.0025188299999999997 - 27.0 * Math.pow(0.00167922, 3.0) / 32.0) * Math.sin(2.0 * CS_U1) + (21.0 * Math.pow(0.00167922, 2.0) / 16.0 - 55.0 * Math.pow(0.00167922, 4.0) / 32.0) * Math.sin(4.0 * CS_U1) + 151.0 * Math.pow(0.00167922, 3.0) / 96.0 * Math.sin(6.0 * CS_U1) + 1097.0 * Math.pow(0.00167922, 4.0) / 512.0 * Math.sin(8.0 * CS_U1);
            let CS_V1 = 6378137.0 / Math.pow(1.0 - 0.00669438 * Math.pow(Math.sin(CS_LAT1), 2.0), 0.5);
            let CS_P1 = 6335439.32722994 / Math.pow(1.0 - 0.00669438 * Math.pow(Math.sin(CS_LAT1), 2.0), 1.5);
            let CS_T1 = Math.pow(Math.tan(CS_LAT1), 2.0);
            let CS_C1 = 0.00674 * Math.pow(Math.cos(CS_LAT1), 2.0);
            let CS_D = (parseFloat(grs80TmX) - 200000.0) / CS_V1 / 1.0;
            let CS_LAT = CS_LAT1 - CS_V1 * Math.tan(CS_LAT1) / CS_P1 * Math.pow(CS_D, 2.0) / 2.0 - (5.0 + 3.0 * CS_T1 + 10.0 * CS_C1 - 4.0 * Math.pow(CS_C1, 2.0) - 0.060660000000000006) * Math.pow(CS_D, 4.0) / 24.0 + (61.0 + 90.0 * CS_T1 + 298.0 * CS_C1 + 45.0 * Math.pow(CS_T1, 2.0) - 1.69848 - 3.0 * Math.pow(CS_C1, 2.0)) * Math.pow(CS_D, 6.0) / 720.0;
            let CS_LON = 2.216568150032798 + (CS_D - (1.0 + 2.0 * CS_T1 + CS_C1) * Math.pow(CS_D, 3.0) / 6.0 + (5.0 - 2.0 * CS_C1 + 28.0 * CS_T1 - 3.0 * Math.pow(CS_C1, 2.0) + 0.05392 + 24.0 * Math.pow(CS_T1, 2.0)) * Math.pow(CS_D, 5.0) / 120.0) / Math.cos(CS_LAT1);
            let wgs84X = CS_LON * 180.0 / 3.141592653589793;
            let wgs84Y = CS_LAT * 180.0 / 3.141592653589793;

            return [wgs84Y.toFixed(7), wgs84X.toFixed(7)];
        },
        makeHtmlMarker(addongNm, value, unit, level, type) {
            let left = '-6px';
            if($_WC.viewScale > 1) {
                left = '-45px';
            }
            if($_WC.isMobile) {
                left = '5px';
            }
            let dimClass = "";
            if(level == 'good') {
                dimClass = "dim01";
            } else if(level == 'normal') {
                dimClass = "dim02";
            } else if(level == 'bad') {
                dimClass = "dim03";
            } else if(level == 'worse') {
                dimClass = "dim04";
            } else if(level == 'elec') {
                dimClass = "dim06";
            } else if(level == 'gas') {
                dimClass = "dim07";
            } else if(level == 'localHeat') {
                dimClass = "dim08";
            } else if(level == 'co2') {
                dimClass = "dim09";
            }  else {
                dimClass = "dim05";
            }
            let dpVal = value;
            if(typeof value === 'undefined' || value === '-' || value === '' || dimClass === 'dim05' || isNaN(value)) {
                dpVal = "점검중";
                if(["gas","elec","localHeat","co2"].includes(level)) {
                    dimClass = "dim05";
                    dpVal = '-'
                }
            }

            let addClass = '';
            let addHtml = '';
            if(typeof type !== $_TYPE.UNDEF && type !== '') {
                addClass = 'line3';
                addHtml = '<p class="dim_pl top">' + type + '</p>';
            }

            let html = '<div class="dim_info ' + addClass + ' ' + dimClass + '" style="left:' + left + '">';
            if(addHtml !== '') {
                html += addHtml;
            }

            html += '<p class="dim_no">' + dpVal;
            if(dpVal !== '점검중') {
                html += '<span>' + unit + '</span>';
            }
            html += '</p>';
            html += '<p class="dim_pl">' + addongNm + '</p>';
            html += '</div>';
            return html;
        },




        removePolygon(key) {
            if(this.hasPolygons(key)) {
                this.showPolygons(key, false);
                delete this.polygonMap[key];
            }
        },


        makePolygonByStringReverse: function(geoJsonKeyType, key, geoJsonString, color, opacity, clickHandle, mapKey) {
            // type: prop or file prop인 경우 key는 프로퍼티명
            let keyNm = key;
            
            let geoJson = geoJsonString;
            let newFeatures = geoJson.features; 

            if(typeof newFeatures !== 'undefined') {
            	newFeatures.map(function(currVal, idx, arr) {
                    if(geoJsonKeyType === this.geoJsonKeyType.prop) {
                        let prop = currVal.properties;
                        keyNm = prop[key];
                    } else if(geoJsonKeyType === this.geoJsonKeyType.feature) {
                        keyNm = currVal[key];
                    }
                    
                    let coordinates = currVal.geometry.coordinates;
                    coordinates.forEach(function(paths, index) {
                        let newPaths = paths;
                        if(newPaths.length == 1) {
                            newPaths = newPaths[0];
                        }
                        newPaths.forEach(function(p){
                        	p.reverse();
                        });
                        this.drawPolygon(keyNm, newPaths, color, opacity, clickHandle, mapKey, color);
                    }, this);
                }.bind(this));
            } else if(typeof geoJson.coordinates !== 'undefined') {
            	let coordinates = geoJson.coordinates;
                coordinates.forEach(function(paths, index) {
                    let newPaths = paths;
                    if(newPaths.length == 1) {
                        newPaths = newPaths[0];
                    }
                    newPaths.forEach(function(p){
                    	p.reverse();
                    });
                    this.drawPolygon(keyNm, newPaths, color, opacity, clickHandle, mapKey, color);
                }, this);
            } else if(typeof geoJson.geometry !== 'undefined') {
                if(geoJsonKeyType === this.geoJsonKeyType.prop) {
                    let prop = geoJson.properties;
                    keyNm = prop[key];
                } else if(geoJsonKeyType === this.geoJsonKeyType.feature) {
                    keyNm = geoJson[key];
                }
                
            	let coordinates = geoJson.geometry.coordinates;
                coordinates.forEach(function(paths, index) {
                    let newPaths = paths;
                    if(newPaths.length == 1) {
                        newPaths = newPaths[0];
                    }
                    newPaths.forEach(function(p){
                    	p.forEach(function(p2){
                    		if(Array.isArray(p2)){
                    			p2.reverse();                    			
                    		}
                    	});
                    	p.reverse();
                    });
                    this.drawPolygon(keyNm, newPaths, color, opacity, clickHandle, mapKey, color);
                }, this);                
            }
            
        },


        makePolylineString: function(geoJsonKeyType, key, geoJson, strokeColor, strokeWeight, strokeStyle, showIcon, opacity, clickHandle, mapKey) {
            // type: prop or file prop인 경우 key는 프로퍼티명
            let keyNm = key;
            let newFeatures = [];
            if(geoJson.type === 'Feature') {
                newFeatures[0] = geoJson;
            } else {
                // FeatureCollection
                newFeatures = geoJson.features;
            }
            
            newFeatures.map(function(currVal, idx, arr) {
                if(geoJsonKeyType === this.geoJsonKeyType.prop) {
                    let prop = currVal.properties;
                    keyNm = prop[key];
                } else if(geoJsonKeyType === this.geoJsonKeyType.feature) {
                    keyNm = currVal[key];
                }
                
                let geometryType = currVal.geometry.type;
                let coordinates = [];
                if(geometryType === 'LineString') {
                    coordinates[0] = currVal.geometry.coordinates;
                } else {
                    // MultiLineString
                    coordinates = currVal.geometry.coordinates;
                }
                coordinates.forEach(function(paths, index) {
                    let newPaths = paths;
                    if(newPaths.length == 1) {
                        newPaths = newPaths[0];
                    }
                    this.drawPolyline2(keyNm, newPaths, strokeColor, strokeWeight, strokeStyle, showIcon, opacity, clickHandle, mapKey);
                }, this);
            }.bind(this));
        },


        drawPolyline2: function(key, paths, strokeColor, strokeWeight, strokeStyle, showIcon, opacity, clickHandle, mapKey) {
            if(typeof mapKey === 'undefined') {
                mapKey = key;
            }
            if(typeof this.polylineMap[mapKey] === 'undefined') {
                this.polylineMap[mapKey] = [];
            }
            
            if(typeof strokeStyle === 'undefined') {
                strokeStyle = 'solid';
            }
            
        	var polyline = new naver.maps.Polyline({
            	path: paths,
            	strokeColor: strokeColor,
            	strokeOpacity: opacity,
            	strokeWeight: Math.ceil(strokeWeight * $_WC.viewScale),
            	strokeStyle: strokeStyle,
            	strokeLineJoin: 'round',
            	endIcon: 2,
            	zIndex: 100,
                endIconSize: Math.ceil(strokeWeight * $_WC.viewScale) * 2,
            });
            
        	if(showIcon) {
        	    polyline.setOptions({
                    startIcon: 3,
                    startIconSize: Math.ceil(strokeWeight * $_WC.viewScale) * 2,
                    endIcon: 3,
                    endIconSize: Math.ceil(strokeWeight * $_WC.viewScale) * 2,        	        
        	    });
        	}
        	
        	if(typeof clickHandle === 'function') {
        	    polyline.setClickable(true);
        	    naver.maps.Event.addListener(polyline, 'click', function(event) {
        	        polyline.coord = event.coord;
                    this.$store.dispatch("SET_SELECTED_MARKER", polyline);
        	        clickHandle(key, event);
                }.bind(this));
                
                //naver.maps.Event.trigger(marker, 'click', null);
        	}
        	
            this.polylineMap[mapKey].push(polyline);
            polyline.setMap(this.map);
        },
    }
};
